import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixDialog from "@radix-ui/react-dialog";
import { memo } from "react";
export const ActionSheetOverlay = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixDialog.Overlay, {
        className: tailwindMerge("fixed inset-0 z-portal bg-black/60", className),
        "data-testid": "ACTION_SHEET_OVERLAY",
        ...restOfProps
    });
});
ActionSheetOverlay.displayName = "ActionSheetOverlay";
